<!-- Loading -->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header compact-header">
  <div class="container-fluid">
    <div class="header-row">

      <a href="javascript:void(0)" (click)="goBack()" class="back-btn">
        <i class="fa fa-arrow-left"></i>
      </a>

      <h5 class="page-title mb-0">
        Re-upload Vehicle Transfer Photos
      </h5>

      <a routerLink="/" class="home-btn">
        <i class="fas fa-home"></i>
      </a>
    </div>

  </div>
</section>
<!-- /.content-header -->
<section class="content">
  <div class="container-fluid">

    <div class="card shadow-sm rounded-lg">

      <!-- Header -->
      <div class="card-header">
        <small class="mb-0 text-danger font-weight-bold">
          Re-upload/Add More Photos for {{chassis_no}}
        </small>
      </div>

      <div class="card-body">
        <!-- Carousel -->
        <div id="photoCarousel"
             class="carousel slide mb-4"
             data-ride="carousel">

          <ol class="carousel-indicators">
            <li *ngFor="let photo of photos; let i = index"
                [class.active]="i === 0"
                data-target="#photoCarousel"
                [attr.data-slide-to]="i">
            </li>
          </ol>

          <div class="carousel-inner rounded-lg shadow-sm">
            <div *ngFor="let photo of photos; let i=index"
                 class="carousel-item"
                 [class.active]="i===0">

              <img [src]="photo.image_url"
                   class="d-block w-100 vehicle-img"
                   alt="Vehicle Photo">
            </div>
          </div>

          <a class="carousel-control-prev"
             href="#photoCarousel"
             role="button"
             data-slide="prev">
            <span class="carousel-control-prev-icon"></span>
          </a>

          <a class="carousel-control-next"
             href="#photoCarousel"
             role="button"
             data-slide="next">
            <span class="carousel-control-next-icon"></span>
          </a>

        </div>

        <div class="col-12">
          <form (ngSubmit)="handleSubmit()">
            <ngx-dropzone (change)="onSelect($event)">
                <ngx-dropzone-label>Tap to upload photos!</ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-image-preview>
            </ngx-dropzone>

            <div class="mt-4" >
                <button class="btn btn-success" type="button" *ngIf="isUploading; else showUploadBtn" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Uploading...
                </button>

                <ng-template #showUploadBtn>
                    <button type="submit" class="btn btn-success rounded-pill upload-btn"><i class="fas fa-upload fa-sm" aria-hidden="true">&nbsp;</i>Upload</button>
                </ng-template>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
